module.exports = __webpack_public_path__ + "static/img/check_filter.e064960b.svg";